/**
 * 控制台布局（S04）：左侧导航 + 顶部项目切换器/用户区 + 右侧内容区。
 */

import {
  ExperimentOutlined,
  RobotOutlined,
  SettingOutlined,
  TrophyOutlined,
  AppstoreOutlined,
  ClusterOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Dropdown, Layout, Menu, Select, Space, Typography } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useProject } from "../lib/project";

const { Sider, Header, Content } = Layout;

const NAV_ITEMS = [
  { key: "/projects", icon: <AppstoreOutlined />, label: "项目" },
  { key: "/experiments", icon: <ExperimentOutlined />, label: "实验" },
  { key: "/arena", icon: <TrophyOutlined />, label: "竞技场" },
  { key: "/fleet", icon: <ClusterOutlined />, label: "设备舰队" },
  { key: "/models", icon: <RobotOutlined />, label: "模型" },
  { key: "/settings", icon: <SettingOutlined />, label: "设置" },
];

export function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const { projects, projectId, projectLoading, switchProject } = useProject();

  const selectedKey =
    NAV_ITEMS.find((n) => location.pathname.startsWith(n.key))?.key ?? "/projects";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider theme="dark" width={200}>
        <div style={{ color: "#fff", padding: "20px 16px", fontWeight: 700, fontSize: 16 }}>
          ATC 平台
          <div style={{ fontWeight: 400, fontSize: 12, color: "#bbb" }}>
            Action-Training-Cycle
          </div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={NAV_ITEMS}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "0 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Space>
            <Typography.Text type="secondary">当前项目</Typography.Text>
            <Select
              value={projectId ?? undefined}
              onChange={switchProject}
              loading={projectLoading}
              placeholder={projectLoading ? "加载中" : "选择项目"}
              style={{ minWidth: 180 }}
              options={projects.map((p) => ({ value: p.id, label: p.name }))}
            />
          </Space>
          <Dropdown
            menu={{
              items: [{ key: "signout", label: "退出登录" }],
              onClick: async ({ key }) => {
                if (key === "signout") await signOut();
              },
            }}
          >
            <Space style={{ cursor: "pointer" }}>
              <Avatar size="small" icon={<UserOutlined />} />
              <Typography.Text>{user?.email ?? user?.id ?? "未命名用户"}</Typography.Text>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ padding: 24, overflow: "auto" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
